<script setup lang="ts">
import DiagnosticResultSection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/DiagnosticResultSection.vue'
import PartStatusSection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/PartStatusSection.vue'
import RepairChargesSection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/RepairChargesSection.vue'
import RepairDetailsSection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/RepairDetailsSection.vue'
import ReplacedPartSection from '@/components/rc/miner-repairs/repairs-sidebar/part-sidebar-sections/ReplacedPartSection.vue'
import { useRepairsContext } from '@/composables/rc/drawer-context'

import { usePartDetails } from '@/composables/rc/part-details'

defineProps<{ customerId: number }>()

const { minerId, selectedPart } = useRepairsContext()
const { hasFailure, failureId, isReplacement } = usePartDetails(minerId, selectedPart)
</script>

<template>
  <div class="flex flex-col gap-spacing-xl">
    <DiagnosticResultSection />
    <RepairDetailsSection v-if="hasFailure && !isReplacement" :failure-id="failureId!" />
    <ReplacedPartSection v-if="isReplacement" />
    <RepairChargesSection v-if="hasFailure" />
    <PartStatusSection v-if="hasFailure" />
  </div>
</template>
